module.exports = __webpack_public_path__ + "img/product-showcase-gallery-02.401242e1.jpg";